import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
// tslint:disable-next-line: max-line-length
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
// tslint:disable-next-line: max-line-length
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ShimanoPaginationModule } from '../../pagination/pagination.module';
import { SortingModule } from '../../sorting/sorting.module';
import { TableModule } from '../../table/table.module';
import { TooltipTextModule } from '../../tooltip-text/tooltip-text.module';
// tslint:disable-next-line: max-line-length
import { SavedCartsListActionsCellComponent } from './saved-carts-list-actions-cell/saved-carts-list-actions-cell.component';
// tslint:disable-next-line: max-line-length
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { SavedCartsListDeleteModalComponent } from './saved-carts-list-delete-modal/saved-carts-list-delete-modal.component';
import { ErrorListModalComponent } from './saved-carts-list-desc-cell/error-list-modal/error-list-modal.component';
import { SavedCartsListDescCellComponent } from './saved-carts-list-desc-cell/saved-carts-list-desc-cell.component';
import { SavedCartsListNameCellComponent } from './saved-carts-list-name-cell/saved-carts-list-name-cell.component';
import { SavedCartsListRestoreModalComponent } from './saved-carts-list-restore-modal/saved-carts-list-restore-modal.component';
import { SavedCartsListComponent } from './saved-carts-list.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    TableModule,
    MatMenuModule,
    MatIconModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    SortingModule,
    SharedModule,
    RouterModule,
    UrlModule,
    ShimanoPaginationModule,
    TooltipTextModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SavedCartsListComponent: {
          component: SavedCartsListComponent,
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.SavedCarts,
    }),
  ],
  declarations: [
    SavedCartsListComponent,
    SavedCartsListActionsCellComponent,
    SavedCartsListDeleteModalComponent,
    SavedCartsListRestoreModalComponent,
    SavedCartsListNameCellComponent,
    SavedCartsListDescCellComponent,
    ErrorListModalComponent,
  ],
  exports: [
    SavedCartsListComponent,
    SavedCartsListActionsCellComponent,
    SavedCartsListDeleteModalComponent,
    SavedCartsListRestoreModalComponent,
    SavedCartsListNameCellComponent,
    SavedCartsListDescCellComponent,
    ErrorListModalComponent,
  ],
})
export class SavedCartsListModule {}
